// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-edit-set-groups {
    margin-left: var(--space);
    border-radius: 8px;
    background: var(--new-background-color);
    background: var(--white-color);
}

.tournament-edit-set-groups__classify-teams .baloa-subtitle-1 {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-and-half);
}

.tournament-edit-set-groups__classify-teams {
    background-color: var(--new-light-gray-background-color);
    border-radius: var(--space-half) var(--space-half) 0 0;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 12px 20px;
}

.tournament-edit-set-groups__teams-to-classify {
    display: flex;
    align-items: center;
}

.tournament-edit-set-groups__teams-to-classify .baloa-normal-medium {
    color: var(--primary-dark-color);
    margin-right: var(--space);
}

.tournament-edit-set-groups__classify-counter__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--new-background-color);
    border-radius: var(--space-quarter);
    padding: var(--space-quarter);
}

.tournament-edit-set-groups__classify-counter {
    width: var(--space-x2);
    height: var(--space-x2);
    border-radius: var(--space-quarter);
    background-color: var(--new-green-color);
    color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tournament-edit-set-groups__classify-counter.baloa-normal-medium {
    color: var(--white-color);
    margin: 0;
}

.tournament-edit-set-groups__classify-counter__container input {
    border: none;
    background-color: transparent;
    width: var(--space-x3);
    text-align: center;
}

.tournament-edit-set-groups__classify-counter__container input:focus{
    outline: none;
}

.tournament-edit-set-groups__classify-counter__container input[type=number]::-webkit-inner-spin-button,
.tournament-edit-set-groups__classify-counter__container input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.tournament-edit-set-groups__team-list__team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-half-quarter) 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-edit-set-groups__team-list__team-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.tournament-edit-set-groups__team-list__team-info__img .icon-ball {
    font-size: calc(var(--space-and-half) + var(--space-eighth));
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: var(--space-quarter);
    height: 35px;
    color: var(--white-color);
}

.tournament-edit-set-groups__team-list__team-info__img img {
    border-radius: 50%;
    height: 35px;
    width: 35px;
}

.tournament-edit-set-groups__team-list__container {
    padding: var(--space);
}

.tournament-edit-set-groups__team-list__team-info .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-left: var(--space);
}

.tournament-edit-set-groups__team-list__team-action {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tournament-edit-set-groups__team-list__team-info__img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-edit-set-groups__team-list__empty {
    display: flex;
    height: 40vh;
    align-items: center;
    justify-content: center;
}

.tournament-edit-set-groups__team-list {
    max-height: 450px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-edit-set-groups/TournamentEditSetGroupsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,wDAAwD;IACxD,sDAAsD;IACtD,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6CAA6C;IAC7C,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,wCAAwC;IACxC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;IACpC,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,4DAA4D;IAC5D,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".tournament-edit-set-groups {\n    margin-left: var(--space);\n    border-radius: 8px;\n    background: var(--new-background-color);\n    background: var(--white-color);\n}\n\n.tournament-edit-set-groups__classify-teams .baloa-subtitle-1 {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-edit-set-groups__classify-teams {\n    background-color: var(--new-light-gray-background-color);\n    border-radius: var(--space-half) var(--space-half) 0 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 12px 20px;\n}\n\n.tournament-edit-set-groups__teams-to-classify {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-edit-set-groups__teams-to-classify .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    margin-right: var(--space);\n}\n\n.tournament-edit-set-groups__classify-counter__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--new-background-color);\n    border-radius: var(--space-quarter);\n    padding: var(--space-quarter);\n}\n\n.tournament-edit-set-groups__classify-counter {\n    width: var(--space-x2);\n    height: var(--space-x2);\n    border-radius: var(--space-quarter);\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.tournament-edit-set-groups__classify-counter.baloa-normal-medium {\n    color: var(--white-color);\n    margin: 0;\n}\n\n.tournament-edit-set-groups__classify-counter__container input {\n    border: none;\n    background-color: transparent;\n    width: var(--space-x3);\n    text-align: center;\n}\n\n.tournament-edit-set-groups__classify-counter__container input:focus{\n    outline: none;\n}\n\n.tournament-edit-set-groups__classify-counter__container input[type=number]::-webkit-inner-spin-button,\n.tournament-edit-set-groups__classify-counter__container input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.tournament-edit-set-groups__team-list__team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space-half-quarter) 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-edit-set-groups__team-list__team-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.tournament-edit-set-groups__team-list__team-info__img .icon-ball {\n    font-size: calc(var(--space-and-half) + var(--space-eighth));\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: var(--space-quarter);\n    height: 35px;\n    color: var(--white-color);\n}\n\n.tournament-edit-set-groups__team-list__team-info__img img {\n    border-radius: 50%;\n    height: 35px;\n    width: 35px;\n}\n\n.tournament-edit-set-groups__team-list__container {\n    padding: var(--space);\n}\n\n.tournament-edit-set-groups__team-list__team-info .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-left: var(--space);\n}\n\n.tournament-edit-set-groups__team-list__team-action {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.tournament-edit-set-groups__team-list__team-info__img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-edit-set-groups__team-list__empty {\n    display: flex;\n    height: 40vh;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-edit-set-groups__team-list {\n    max-height: 450px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
